import {Component, ElementRef, HostBinding, OnInit, ViewChild} from '@angular/core';
import {AlertController, IonContent, IonFooter, IonHeader, Platform} from '@ionic/angular';

import {TranslateService} from '@ngx-translate/core';

import {Daytime, DaytimeService} from 'shared/daytime';
import {Credentials} from '../../model/interfaces';
import {CredentialsService} from '../../services/credentials.service';
import {LoginService} from '../../services/login.service';

import {UserService} from 'app/profile';
import {UserProfile} from 'app/profile/model/model';
import {LocalSettingsService} from 'shared/local-settings/local-settings.service';
import {NavService} from 'shared/nav/nav.service';

import { Browser } from '@capacitor/browser';
import * as teams from 'shared/teams/teams-checker';
import { FCMService } from 'shared/fcm/fcm.service';
import { HyphenateService } from 'shared/helpers/hyphenate.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'login-page',
  templateUrl: 'login-page.html',
  styleUrls: ['login-page.scss'],
})
export class LoginPage implements OnInit {

  public greeting: string = '';
  public name: string = '';
  public nameParam = {name: ''};

  public authenticated: boolean = false;
  public username: string;
  public password: string;

  public isPlayingAnimation: boolean = false;

  private loginTimeout: number = 500;

  private autoLogin: boolean;

  public onboarding: boolean = false;

  public devOnboarding: boolean = false;

  private modMarginTop;
  private modMaxRingWidth;

  public mode: string = '';

  @ViewChild(IonHeader, { read: ElementRef }) ionHeader: ElementRef<HTMLIonHeaderElement>;
  @ViewChild(IonContent, { read: ElementRef }) ionContent: ElementRef<HTMLIonContentElement>;
  @ViewChild(IonFooter, { read: ElementRef }) ionFooter: ElementRef<HTMLIonFooterElement>;
  @ViewChild('ringContainer') private ringContainer: ElementRef<HTMLDivElement>;

  constructor(
    public platform: Platform,
    public navService: NavService,
    public alertCtrl: AlertController,
    public loginService: LoginService,
    public credentialsService: CredentialsService,
    public translateService: TranslateService,
    public daytimeService: DaytimeService,
    public userService: UserService,
    private localSettingsService: LocalSettingsService,
    private fcmService: FCMService,
    private hyphenateService: HyphenateService,
  ) { }

  ionViewWillEnter() {
    this.onResize();
  }

  ionViewDidEnter() {
    this.localSettingsService.doWaiting(this.initLogin.bind(this));
  }

  onResize() {
    if ( this.ringContainer === undefined || this.ringContainer.nativeElement === undefined ) {
      setTimeout(() => { this.onResize(); }, 200);
    }
    else if ( this.ringContainer.nativeElement.style.marginTop != '40vh' ) {
      this.ringContainer.nativeElement.style.marginTop = '40vh';
      setTimeout(() => { this.onResize(); }, 100);
    }
    else {
      const hh = this.ionHeader.nativeElement.offsetHeight;
      const hc = this.ionContent.nativeElement.offsetHeight;
      const hf = this.ionFooter.nativeElement.offsetHeight;
      const t = this.ringContainer.nativeElement.offsetTop;
      const hR = this.ringContainer.nativeElement.scrollHeight;
      let t1, t2;
      // besser zentrieren
      if ( (hh+hc+hf) / 2 - hh < t ) {
        t1 = (hh+hc+hf) / 2 - hh;
        console.log("mod ring position1 " + hh + " " + hc + " " + hf + " " + hR + " " +  t + " => " + t1);
      }
      if ( t + hR / 2 + 40 > hc ) {
        t2 = Math.max(hc - hR / 2 - 40, 16);
        console.log("mod ring position2 " + hh + " " + hc + " " + hf + " " + hR + " " +  t + " => " + t2);
      }
      let tNeu;
      if ( t1 !== undefined ) {
        tNeu = t1;
      }
      if ( t2 !== undefined ) {
        tNeu = (t1 !== undefined ? Math.min(t1, t2) : t2);
      }
      if ( tNeu != undefined ) {
        this.ringContainer.nativeElement.style.marginTop = tNeu+'px';
        this.modMarginTop = tNeu+'px';
      }
      if ( hR + 40 > hc ) {
        this.modMaxRingWidth = (hR-40)+'px';
        this.ringContainer.nativeElement.style.maxWidth = this.modMaxRingWidth;
        this.ringContainer.nativeElement.style.maxHeight = this.modMaxRingWidth;
      }
    }
  }

  public ngOnInit(): void {
    if (this.navService.get('autoLogin') !== false) {
      this.autoLogin = true;
    }
    else if (this.navService.get('autoLogin') === false) {
      this.credentialsService.removeCredentials();
    }

    this.devOnboarding = this.navService.get('devOnboarding');

    this.daytimeService.getDaytime().subscribe((daytime: Daytime) => {
      switch (daytime) {
        case Daytime.Morning: this.greeting = 'LOGIN.GREETING.MORNING'; break;
        case Daytime.Midday: this.greeting = 'LOGIN.GREETING.DAY'; break;
        case Daytime.Evening: this.greeting = 'LOGIN.GREETING.EVENING'; break;
        case Daytime.Resilience: this.greeting = 'LOGIN.GREETING.EVENING'; break;
        case Daytime.Night: this.greeting = 'LOGIN.GREETING.NIGHT'; break;
        default: this.greeting = 'LOGIN.GREETING.MORNING'; break;
      }
    });
  }

  private initLogin(): void {
    this.localSettingsService.get(LocalSettingsService.MODE)
      .then((mode) => {
        // autologin?
        try {
          this.credentialsService.hasCredentials().subscribe((hasCredentials: boolean) => {
            if (hasCredentials) {
              // if credentials but no modem then it is an App Update, so use standard
              this.mode = ( mode == null ) ? 'standard' : mode;
              this.userService.setMode(this.mode);
              this.credentialsService.getCredentials().subscribe((credentials: Credentials) => {
                this.username = credentials.username;
                this.password = credentials.password;

                if (this.autoLogin) {
                  this.login(credentials.username, credentials.password);
                } else {
                  this.showLoginPrompt(credentials.username, credentials.password);
                }
              });

              return;
            }

            if (mode == null) {
              this.navService.push('login/mode');
              return;
            }
            else {
              this.mode = mode;
              this.userService.setMode(mode);
            }

            this.showLoginPrompt('', '');
          });
        } catch (e) {
          console.log('~~~ ' + e)
        }
      });
  }

  private onLoginSuccess(username: string, password: string): void {
    this.username = username;
    this.password = password;
    this.authenticated = true;
    this.isPlayingAnimation = true;
    this.credentialsService.saveCredentials(username, password);
    if (this.fcmService.recentlyActionPerformed(false) || teams.checkInTeams()) {
      this.navService.root('dashboard', {username: this.username, password: this.password, modMarginTop: this.modMarginTop, modMaxRingWidth: this.modMaxRingWidth});
      return;
    }
    this.name = '';
    this.userService.getUserProfile('firstname,settings,onboarding').subscribe((profile: UserProfile) => {
      this.name = profile.firstname;
      this.nameParam = {name: this.name};
      this.onboarding = profile['onboarding'];
      this.daytimeService.getDaytime().subscribe((daytime: Daytime) => {
        if ( this.name !== undefined) {
          switch (daytime) {
            case Daytime.Morning: this.greeting = 'LOGIN.GREETING_WITH_NAME.MORNING'; break;
            case Daytime.Midday: this.greeting = 'LOGIN.GREETING_WITH_NAME.DAY'; break;
            case Daytime.Evening: this.greeting = 'LOGIN.GREETING_WITH_NAME.EVENING'; break;
            case Daytime.Resilience: this.greeting = 'LOGIN.GREETING_WITH_NAME.EVENING'; break;
            case Daytime.Night: this.greeting = 'LOGIN.GREETING_WITH_NAME.NIGHT'; break;
            default: this.greeting = 'LOGIN.GREETING_WITH_NAME.MORNING'; break;
          }
        } else {
          // overwrite the greeting (again), because the user may have changed and the new user has no first name
          switch (daytime) {
            case Daytime.Morning: this.greeting = 'LOGIN.GREETING.MORNING'; break;
            case Daytime.Midday: this.greeting = 'LOGIN.GREETING.DAY'; break;
            case Daytime.Evening: this.greeting = 'LOGIN.GREETING.EVENING'; break;
            case Daytime.Resilience: this.greeting = 'LOGIN.GREETING.EVENING'; break;
            case Daytime.Night: this.greeting = 'LOGIN.GREETING.NIGHT'; break;
            default: this.greeting = 'LOGIN.GREETING.MORNING'; break;
          }
        }
      });
      this.localSettingsService.get(LocalSettingsService.THEME)
        .then((result) => {
          if (result == null ) {
            this.userService.getUserProfile('full').subscribe((profile: UserProfile) => {
              const themes: Array<string> = this.userService.getCompanyThemes(profile);
              if (themes.length > 0) {
                this.localSettingsService.set(LocalSettingsService.THEME, themes[0]+ ' light');
              }
              else {
                this.localSettingsService.set(LocalSettingsService.THEME, 'standard light');
              }
            });
          }
        });
      if (this.onboarding) {
        this.userService.getUserProfile('full').subscribe((profile: UserProfile) => {
          const themes: Array<string> = this.userService.getCompanyThemes(profile);
          if (themes.length > 0) {
            this.localSettingsService.set(LocalSettingsService.THEME, themes[0]);
          }
        });
      }
      this.onboarding = this.onboarding || this.devOnboarding;
      if ( this.mode == 'simple' ) {
        console.log("SIMPLE")
        setTimeout(() => this.onNextClick());
      }
      else {
        setTimeout(() => this.onNextClick(), this.onboarding ? 17000 : 6000);  // Animationsdauer
      }
    });
    this.userService.getTargetGroups().subscribe((groups: Array<any>) => {
      console.log("+++ %o", groups);
      if (groups.length > 0) {
        this.hyphenateService.setTargetGroup(groups[0]);
      }
    });
  }

  private onLoginError(username: string, password: string, err: HttpErrorResponse): void {
    setTimeout(() => {this.showErrorAlert(username, password, err.status == 401 ? 'UNAUTHORIZED' : 'TECHNICAL');} );
    //setTimeout(() => {this.showLoginPrompt(username, password); }, this.loginTimeout);
  }

  private login(username: string, password: string): void {

    this.loginService.login(username, password).subscribe({
        next: this.onLoginSuccess.bind(this, username, password),
        error: err => { this.onLoginError(username, password, err); },
      });
  }

  private showLoginPrompt(username: string, password: string) {

    this.translateService.get([
      'LOGIN.TITLE',
      'LOGIN.FORGOT_PASSWORD',
      'LOGIN.LOGIN',
      'LOGIN.USERNAME_PLACEHOLDER',
      'LOGIN.PASSWORD_PLACEHOLDER',
      'LOGIN.REGISTERINFO',
      'LOGIN.REGISTER',
    ]).subscribe(async(translations) => {

      const titleLabel: string = translations['LOGIN.TITLE'];
      const forgotPasswordLabel: string = translations['LOGIN.FORGOT_PASSWORD'];
      const loginLabel: string = translations['LOGIN.LOGIN'];
      const usernamePlaceholder: string = translations['LOGIN.USERNAME_PLACEHOLDER'];
      const passwordPlaceholder: string = translations['LOGIN.PASSWORD_PLACEHOLDER'];
      const registerInfo: string = translations['LOGIN.REGISTERINFO'].replace(/\&shy;/g, '\u00AD');
      const registerLabel: string = translations['LOGIN.REGISTER'];

      const alert: HTMLIonAlertElement = await this.alertCtrl.create({
        backdropDismiss: false,
        cssClass: 'login',
        header: titleLabel,
        inputs: [
          {
            name: 'username',
            placeholder: usernamePlaceholder,
            value: username,
            type: 'email',
          },
          {
            name: 'password',
            placeholder: passwordPlaceholder,
            type: 'password',
            value: password,
          },
        ],
        buttons: [
          {
            text: loginLabel,
            handler: (data: {username: string, password: string}) => {
              this.login(data.username, data.password);
            },
          },
          {
            text: forgotPasswordLabel,
            handler: (data: {username: string, password: string}): void => {
              this.showResetPasswordPrompt(data.username, data.password);
            },
          },
          {
            text: registerInfo,
            cssClass: 'register-info',
            handler: (data: {username: string, password: string}) => {
              return false;
            },
          },
          {
            text: registerLabel,
            handler: (data: {username: string, password: string}) => {
              this.openUrl('https://register.leada.de/register/Powerimpulse?voucher_code=8275');
              return false;
            },
          },
        ],
      });
      alert.present();
    });
  }

  private showResetPasswordPrompt(username: string, password: string) {

    this.translateService.get([
      'LOGIN.RESET_PASSWORD.TITLE',
      'LOGIN.USERNAME_PLACEHOLDER',
      'COMMON.CANCEL',
      'COMMON.RESET',
    ]).subscribe(async(translations) => {

      const titleLabel: string = translations['LOGIN.RESET_PASSWORD.TITLE'];
      const cancelLabel: string = translations['COMMON.CANCEL'];
      const resetLabel: string = translations['COMMON.RESET'];
      const usernamePlaceholder: string = translations['LOGIN.USERNAME_PLACEHOLDER'];

      const alert = await this.alertCtrl.create({
        backdropDismiss: false,
        header: titleLabel,
        cssClass: 'regular-alert',
        inputs: [
          {
            name: 'username',
            placeholder: usernamePlaceholder,
            value: username,
            type: 'email',
          },
        ],
        buttons: [
          {
            text: cancelLabel,
            role: 'cancel',
            handler: (data: {username: string}): void => {
              this.showLoginPrompt(username, password);
            },
          },
          {
            text: resetLabel,
            handler: (data: {username: string}) => {
              this.resetPassword(data.username);
            },
          },
        ],
      });
      alert.present();
    });
  }

  private resetPassword(username: string): void {

    const onSuccess: (success: boolean) => void = (success) => {
      this.showPasswordResetResult(success);
    };

    const onError: (error: Error) => void = (error) => {
      this.showPasswordResetResult(false);
    };

    this.loginService.resetPassword(username).subscribe(
      onSuccess,
      onError,
    );
  }

  private async showPasswordResetResult(success: boolean) {

    this.translateService.get([
      'LOGIN.RESET_PASSWORD.TITLE',
      'LOGIN.RESET_PASSWORD.SUCCESS',
      'LOGIN.RESET_PASSWORD.ERROR',
      'COMMON.OK',
    ]).subscribe(async(translations) => {

      const titleLabel: string = translations['LOGIN.RESET_PASSWORD.TITLE'];
      const successMessage: string = translations['LOGIN.RESET_PASSWORD.SUCCESS'];
      const errorMessage: string = translations['LOGIN.RESET_PASSWORD.ERROR'];
      const okLabel: string = translations['COMMON.OK'];

      const alert: HTMLIonAlertElement = await this.alertCtrl.create({
        backdropDismiss: false,
        header: titleLabel,
        cssClass: 'regular-alert',
        message: success ? successMessage : errorMessage, // TODO MIG passt das?
        buttons: [
          {
            text: okLabel,
            handler: (data: {username: string}): void => {
              this.showLoginPrompt(this.username, this.password);
            },
          },
        ],
      });
      alert.present();
    });
  }

  public onNextClick(): void {
    if ( this.onboarding ) {
      this.navService.root('onboarding/dialogs', {username: this.username, password: this.password}); // omit theses
    }
    else {
      this.navService.root('dashboard', {
        username: this.username,
        password: this.password,
        name: this.name,
        modMarginTop: this.modMarginTop,
        modMaxRingWidth: this.modMaxRingWidth,
        fromLogin: true,
      });
    }
  }

  public onOnboardingClick(): void {
    this.navService.root('onboarding/position', {username: this.username, password: this.password});
  }

  public onSkipClick(): void {
    this.userService.getUserProfile('full').subscribe((profile: UserProfile) => {
        this.userService.setSettings(<any> { }).subscribe((result: boolean) => {
          this.navService.root('dashboard', {username: this.username, password: this.password, modMarginTop: this.modMarginTop, modMaxRingWidth: this.modMaxRingWidth});
        });
    });
  }

  private openUrl(url: string): void {
    Browser.open({url: url.replace(/\u00AD/g, '')});
  }

  private showErrorAlert(username: string, password: string, msg: string): void {

    this.translateService.get([
      'COMMON.ERROR',
      'LOGIN.'+msg,
      'COMMON.OK',
    ]).subscribe(async(translations) => {
      const titleLabel: string = translations['COMMON.ERROR'];
      const message: string = translations['LOGIN.'+msg];
      const okLabel: string = translations['COMMON.OK'];
      const alert: HTMLIonAlertElement = await this.alertCtrl.create({
        header: titleLabel,
        message: message,
        cssClass: 'regular-alert',
        buttons: [
          {
            text: okLabel,
            handler: () => {this.showLoginPrompt(username, password); },
          },
        ],
      });
      alert.present();
    });
  }
}
